import { Route, Routes, Navigate } from "react-router-dom";
import { AgencyAuthProvider } from "../contexts/AgencyAuthContext";
import { AgencyProtectedRoute } from "../components/auth/AgencyProtectedRoute";
import { AuthLayout } from "@/pages/auth/Layout";
import { AgencySignUp } from "../pages/agency/auth/SignUp";
import { AgencyLogin } from "../pages/agency/auth/Login";
import { AgencyLayout } from "../layouts/agency/AgencyLayout";
import { AgencyDashboard } from "../pages/agency/Dashboard";
import { AgencyBrands } from "../pages/agency/Brands";
import { AgencyLinks } from "../pages/agency/Links";
import { AgencyPayouts } from "../pages/agency/Payouts";
import { AgencySettings } from "../pages/agency/Settings";
import Faq from "@/pages/Faq";
import { AgencyBlogs } from "@/components/agency/AgencyBlogs";
import { AgencyBlogDetails } from "@/components/agency/AgencyBlogsDetail";
import { Support } from "@/pages/brand/support/Support";

export function AgencyRoutes() {
  return (
    <AgencyAuthProvider>
      <Routes>
        {/* Auth Routes */}
        <Route
          path="auth"
          element={<AuthLayout navState="small-screen-hide" />}
        >
          <Route path="login" element={<AgencyLogin />} />
          <Route path="signup" element={<AgencySignUp />} />
        </Route>

        {/* Protected Routes */}
        <Route
          element={
            <AgencyProtectedRoute>
              <AgencyLayout />
            </AgencyProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<AgencyDashboard />} />
          <Route path="brands" element={<AgencyBrands />} />
          <Route path="links" element={<AgencyLinks />} />
          <Route path="payouts" element={<AgencyPayouts />} />
          <Route path="settings" element={<AgencySettings />} />
          <Route path="blogs" element={<AgencyBlogs />} />
          <Route path="support" element={<Support />} /> 
          <Route path="blogs/:id" element={<AgencyBlogDetails />} />
          <Route path="faq" element={<Faq />} />
        </Route>
      </Routes>
    </AgencyAuthProvider>
  );
}
